import { normalizeCallOutcomeSlug } from './callOutcomeAnalytics';

/**
 * Verlust-Analyse: häufigste Kombinationen Verlustgrund × Branche × letzter Call-Outcome (wenn in Aktivitäten).
 */
export function buildLossCombos(leads = [], activityByLeadId = {}) {
  const lost = leads.filter(l => l.offerStatus === 'abgelehnt' || (l.status || '').toLowerCase().includes('verloren'));
  const map = {};
  for (const l of lost) {
    const reason = (l.lossReason || '—').trim() || '—';
    const branch = (l.branch || '—').trim() || '—';
    let lastSlug = 'unknown';
    const acts = activityByLeadId[String(l.id)] || activityByLeadId[l.id] || [];
    const calls = acts.filter(a => a.type === 'call');
    if (calls.length) {
      const last = calls.sort((a, b) => new Date(b.ts || 0) - new Date(a.ts || 0))[0];
      lastSlug = normalizeCallOutcomeSlug(last);
    }
    const key = JSON.stringify([reason, branch, lastSlug]);
    map[key] = (map[key] || 0) + 1;
  }
  return Object.entries(map)
    .map(([key, count]) => {
      const [lossReason, branch, lastCallSlug] = JSON.parse(key);
      return { lossReason, branch, lastCallSlug, count };
    })
    .sort((a, b) => b.count - a.count);
}
